import { createSelector } from '@ngrx/store';
import { Balance, NewsCategory } from '@pt/models';
import { environment } from '@pt/environment';

import { balanceFeature } from './balances.reducers';
import { TeamBonusesSelectors } from '../../team-bonuses/store';

const {
  selectBalance,
  selectTeamBalance,
  selectCategories,
  selectGetBalanceAction,
  selectGetBalanceSkinsAction,
  selectApplyBalanceSkinAction,
  selectGetCategoriesAction,
} = balanceFeature;

export interface BalanceViewModel {
  userBalance: Balance;
  balances: Balance[];
  coinsCategory: NewsCategory;
}

const selectViewModel = createSelector(
  selectCategories,
  selectBalance,
  selectTeamBalance,
  (categories, ...balances): BalanceViewModel => ({
    userBalance: balances.filter(Boolean).find(balance => balance.balanceType === 'regular'),
    balances: balances.filter(Boolean)
      .map(balance => ({ title: `balanceCard.title.${balance.balanceType}`, ...balance })),
    coinsCategory: categories.categories
      .find(category => category.name === (environment.coinsCategoryName ?? 'REDCOINS')),
  }),
);

const selectIsLoading = createSelector(
  selectGetBalanceSkinsAction,
  selectApplyBalanceSkinAction,
  selectGetCategoriesAction,
  TeamBonusesSelectors.selectSendAwardAction,
  TeamBonusesSelectors.selectSendBonusAction,
  (
    getBalanceSkinsAction,
    applyBalanceSkinAction,
    getCategoriesAction,
    sendAwardAction,
    sendBonusAction,
  ): boolean => getBalanceSkinsAction.inProgress
    || getCategoriesAction.inProgress
    || applyBalanceSkinAction.inProgress
    || sendAwardAction.inProgress
    || sendBonusAction.inProgress,
);

export const BalanceSelectors = {
  selectBalance,
  selectGetBalanceAction,
  selectApplyBalanceSkinAction,
  selectGetCategoriesAction,
  selectViewModel,
  selectIsLoading,
};
